import { render, staticRenderFns } from "./Secret3.vue?vue&type=template&id=662659dc&scoped=true&"
import script from "./Secret3.vue?vue&type=script&lang=js&"
export * from "./Secret3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662659dc",
  null
  
)

export default component.exports